module.exports = __webpack_public_path__ + "static/media/ZEHUB.4ebbcd40.svg";